<!--
 * @Author: 仙道
 * @Date: 2022-06-15 21:14:56
 * @LastEditTime: 2023-11-27 14:40:27
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/components/RecordInfo.vue
-->
<template>
  <div class="mt-30px">
    <a-descriptions bordered size="small">
      <div class="ant-descriptions-title" slot="title">
        <span>履历统计</span>
        <a-button @click="showStatReport('devResumeReport')" type="link" v-if="!!reportUrl.devResumeReport"
          >更多</a-button
        >
      </div>
      <a-descriptions-item label="保养次数">
        <a-button @click="showStatReport('devMaintainReport')" type="link">{{ resultData.matintain }}</a-button>
      </a-descriptions-item>
      <a-descriptions-item label="缺陷个数">
        <!-- <a-button @click="toOtherPage('/defect/defRegister')" type="link">{{resultData.defect}}</a-button> -->
        <a-button @click="showStatReport('devDefectReport')" type="link">{{ resultData.defect }}</a-button>
      </a-descriptions-item>
      <a-descriptions-item label="巡检次数">{{ resultData.patrol }}</a-descriptions-item>
    </a-descriptions>
    <iframe-drawer ref="iframeDrawer"></iframe-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { putAction, getAction } from '@/api/manage'

export default {
  name: 'TabPanelBase',
  components: {},
  props: {
    deviceData: {
      type: Object,
      default: () => {}
    }
  },
  // 定义属性
  data() {
    return {
      url: '/device/devList/resume',
      catagoryUrl: '/custom/category/rootList',
      getReportUrl: '/custom/commonOnlReport/list',
      resultData: {
        defect: 0,
        matintain: 0,
        patrol: 0
      },
      reportUrl: {
        devResumeReport: ''
      }
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const that = this
    putAction(this.url + '?id=' + this.deviceData.id).then(res => {
      this.resultData = res.result
    })

    getAction(this.catagoryUrl, { code: 'A07' }).then(res => {
      this.reportUrl.devResumeReport = res.result.records[0]?.cusProp1
    })

    getAction(this.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
      if (res.success && res.result) {
        res.result.records.forEach(rep => {
          that.reportUrl[rep.shortName] = rep.url
        })
      }
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    toOtherPage(route) {
      this.$router.push({
        path: route
      })
    },
    showStatReport(reportKey) {
      let url = this.reportUrl[reportKey]
      if (!url) {
        this.$message.warning('未找到统计信息配置')
      }
      if (url.indexOf('?') > -1) {
        url += `&tenantid=${this.$ls.get('TENANT_ID')}`
      } else {
        url += `?tenantid=${this.$ls.get('TENANT_ID')}`
      }
      if (url.indexOf('${devId}') > -1) {
        url = url.replace('${devId}', this.deviceData.id)
      } else {
        url += `&devid=${this.deviceData.id}`
      }
      this.$refs['iframeDrawer'].show(url)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
